<template>
    <div>
        <div class="actModules" >
			<img class="bgImg" :src="bgImg" alt="">
            <h3 class="actModules_title" v-text="modulesTitle">模块名字</h3>
			<div class="actSlider one">
				<Carousel v-model="value1" radius-dot autoplay arrow="never" height="auto">
					<CarouselItem v-for="(item, index) in inviteBags" :key="index">
						<div class="demo-carousel">
							<img :src="item.img" :alt="index">
						</div>
					</CarouselItem>
				</Carousel>
            </div>
            <pre class="actModules_descripe" v-html="modulesRules"></pre>
        </div>
    </div>
</template>
<script>
export default {
	name: 'pc-salesImg',
	actConfig: {
		labels: { // 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '头部文案：',
			bgImg: '背景图片',
			modulesRules: '规则描述：',
			tabItems: 'Tab',
			name: '名称',
			image: '图片',
			action: '动作',
			actionType: '动作类型', // 自定义动作类型，系统内置有 ams: ams动作， link: 跳转到外链
			buttonName: '按钮文案',
			inviteBags: '轮播图'
		},
	},
	props: {
		modulesTitle: {
			type: String,
			default: '模块名字',
			label: '标题',
		},
		modulesRules: {
			type: String,
			default: '活动规则：自定义文案',
			label: '详细说明',
		},
		bgImg: {
			type: String,
			default: '//www.valuecoders.com/blog/wp-content/uploads/2017/11/featurednew.jpeg',
		},
		inviteBags: {
			type: Array,
			default: function () {
				return [
					{
						img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_boxImg.png'
					},
					{
						img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_boxImg.png'
					},
					{
						img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_boxImg.png'
					},
					{
						img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_boxImg.png'
					}
				]
			}
		}
	},
	data () {
		return {
			value1: 0,
		}
	},
	mounted () {

	},
	methods: {
		downBtn () {

		}
	}
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/common';
.actSlider {
  width: 100%;
  margin: 25px auto 0;
  background: #d8d8d8;
  padding: 15px;
  &.one {
    height: auto;
  }
}
.actModules {
	position: relative;
}
.actModules .bgImg{
	position: absolute;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	z-index: -1;
	width: 100%;
	height: 100%;
}
.ivu-carousel img{
	height: auto;
	width: 100%;
}
.actModules_descripe{
	text-align: left;
	padding-left: 15px;
	max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/pc/templates/salesAndGift/salesImg.vue